module.exports = __webpack_public_path__ + "static/media/Comfey_gaussian2.1394fa7d.png";